import React, { useEffect, useRef, useState } from "react";
import {
  HiFilter,
  HiOutlineStatusOffline,
  HiOutlineStatusOnline,
  HiPlus,
  HiSearch,
} from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { TbSquareRoundedCheck, TbSquareRoundedX } from "react-icons/tb";
import WithdrawalWarningPopup from "./WithdrawalWarningPopup";
import axios from "axios";
import WithdrawalApprovedPopup from "./WithdrawalApprovedPopup";
import TableLoader from "Components/Common/Loader/TableLoader";
import Pagination from "Components/Pagination/Pagination";

const RequestedUsersTable = ({ setStatistics }) => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("All Request");
  const [loading, setLoading] = useState(false);
  const dropdownRef = useRef(null);
  const [warnPopupOpen, setWarnPopupOpen] = useState(false);
  const [approvedPopupOpen, setApprovedPopupOpen] = useState(false);
  const [warningMsg, setWarningMsg] = useState("");
  const [withdrawalItem, setWithdrawalItem] = useState([]);
  const [withdrawalRequest, setWithdrawalRequest] = useState([]);
  const [activeTab, setActiveTab] = useState("All");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const handleOpen = (msg, row) => {
    setWarningMsg(msg);
    setWithdrawalItem(row);
    setWarnPopupOpen(true);
  };

  const handelOpenApproved = (msg, row) => {
    setWarningMsg(msg);
    setWithdrawalItem(row);
    setApprovedPopupOpen(true);
  };

  const handleClose = (msg) => {
    setWarningMsg("");
    setWarnPopupOpen(false);
    getWithdrawalRequest();
  };
  const handleCloseApproved = (msg) => {
    setWarningMsg("");
    setApprovedPopupOpen(false);
    getWithdrawalRequest();
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsDropdownOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getWithdrawalRequest();
  }, []);

  const getWithdrawalRequest = async () => {
    try {
      setLoading(true);
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/manual-withdrawal/get-all`,
        headers: {},
      };

      const response = await axios.request(config);
      // console.log(JSON.stringify(response.data));
      let withdrawals = response?.data?.data;
      setWithdrawalRequest(withdrawals);
      let approved = withdrawals.filter((w) => w.status === "Approved");
      let pending = withdrawals.filter((w) => w.status === "Pending");
      setStatistics({
        total: withdrawals.length,
        approved: approved.length,
        pending: pending.length,
      });

      setLoading(false);
    } catch (error) {
      console.log("Error fetching withdrawal request:", error);
      setLoading(false);
    }
  };

  // console.log(
  //   "withdrawalRequest withdrawalRequest withdrawalRequest",
  //   withdrawalRequest
  // );

  useEffect(() => {
    let data = [...withdrawalRequest];
    if (activeTab !== "All") {
      data = data?.filter((r) => r.status === activeTab);
    }

    if (searchTerm.trim()) {
      data = data.filter(
        (r) =>
          r?.kycData?.fullName
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          r?.transactionId?.includes(searchTerm)
      );
    }

    setFilteredData(data);
  }, [activeTab, searchTerm, withdrawalRequest]);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredData?.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(withdrawalRequest?.length / rowsPerPage);
  // const paginate = (pageNumber) => setCurrentPage(pageNumber);

  

  return (
    <React.Fragment>
      <WithdrawalWarningPopup
        withdrawalItem={withdrawalItem}
        warningMsg={warningMsg}
        warnPopupOpen={warnPopupOpen}
        handleClose={handleClose}
      />

      <WithdrawalApprovedPopup
        withdrawalItem={withdrawalItem}
        warningMsg={warningMsg}
        approvedPopupOpen={approvedPopupOpen}
        handleCloseApproved={handleCloseApproved}
      />

      <div className="py-5">
        <div className="flex flex-col items-center justify-between space-y-4 rounded-2xl bg-white p-5 shadow-sm md:flex-row md:space-y-0">
          {/* Filter Dropdown */}
          {/* <div
            className="md:min-w-1/5 relative w-full md:w-1/5"
            ref={dropdownRef}
          >
            <button
              className="flex w-full items-center rounded-md border bg-white px-4 py-2 text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#c51369]"
              onClick={toggleDropdown}
            >
              <HiFilter color="#c51369" className="mr-2 h-5 w-5" />
              {selectedOption}
            </button>
            {isDropdownOpen && (
              <div className="absolute left-0 z-10 mt-2 w-full min-w-max rounded-md border bg-white shadow-lg md:w-auto">
                <ul className="py-2">
                  <li
                    className="cursor-pointer px-4 py-2 hover:bg-gray-100"
                    onClick={() => handleOptionClick("All Request")}
                  >
                    All Request
                  </li>
                  <li
                    className="cursor-pointer px-4 py-2 hover:bg-gray-100"
                    onClick={() => handleOptionClick("Today's Request")}
                  >
                    Today's Request
                  </li>
                  <li
                    className="cursor-pointer px-4 py-2 hover:bg-gray-100"
                    onClick={() => handleOptionClick("Last 7 day's Request")}
                  >
                    Last 7 day's Request
                  </li>
                </ul>
              </div>
            )}
          </div> */}

          {/* Search Bar */}
          <div className="w-full md:mx-4 md:w-1/2 md:flex-1">
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
                <HiSearch color="#c51369" className="h-5 w-5" />
              </span>
              <input
                type="text"
                placeholder="Search..."
                className="block w-full rounded-md border px-4 py-2 pl-10 text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#c51369] md:w-1/2"
                onChange={(e) => {
                  setSearchTerm(e.target.value)
                  setCurrentPage(1)
                }}
              />
            </div>
          </div>
        </div>
        {/* <div className="mt-4 flex border-b">
          <button
            className={`px-4 py-2 text-sm font-medium ${
              activeTab === "Pending"
                ? "border-b-2 border-[#c51369] text-[#c51369]"
                : "text-gray-500"
            } transition-all duration-200 ease-in-out`}
            onClick={() => setActiveTab("Pending")}
          >
            Pending
          </button>
          <button
            className={`px-4 py-2 text-sm font-medium ${
              activeTab === "Approved"
                ? "border-b-2 border-[#c51369] text-[#c51369]"
                : "text-gray-500"
            }`}
            onClick={() => setActiveTab("Approved")}
          >
            Approved
          </button>
          <button
            className={`px-4 py-2 text-sm font-medium ${
              activeTab === "Rejected"
                ? "border-b-2 border-[#c51369] text-[#c51369]"
                : "text-gray-500"
            }`}
            onClick={() => setActiveTab("Rejected")}
          >
            Rejected
          </button>
        </div> */}
        <div className="mx-auto my-1  w-auto rounded-t-2xl">
          <div className="mb-2 flex border-b">
            <button
              className={`px-4 py-2 text-sm font-medium ${
                activeTab === "All"
                  ? "border-b-2 border-[#c51369] text-[#c51369]"
                  : "text-gray-500"
              } transition-all duration-200 ease-in-out`}
              onClick={() => setActiveTab("All")}
            >
              All
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium ${
                activeTab === "Pending"
                  ? "border-b-2 border-[#c51369] text-[#c51369]"
                  : "text-gray-500"
              } transition-all duration-200 ease-in-out`}
              onClick={() => setActiveTab("Pending")}
            >
              Pending
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium ${
                activeTab === "Approved"
                  ? "border-b-2 border-[#c51369] text-[#c51369]"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("Approved")}
            >
              Approved
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium ${
                activeTab === "Rejected"
                  ? "border-b-2 border-[#c51369] text-[#c51369]"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab("Rejected")}
            >
              Rejected
            </button>
          </div>
          {loading ? (
            <TableLoader />
          ) : (
            <div className="overflow-x-auto rounded-t-2xl">
              <table className="w-full rounded-t-2xl text-left text-sm">
                <thead className="text-md bg-[#e0ced7] uppercase tracking-wide text-navy-900">
                  <tr>
                    <th scope="col" className="px-6 py-3">
                      Sl
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Name
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Date
                    </th>
                    <th scope="col" className="px-6 py-3">
                      UPI ID
                    </th>
                    {(activeTab === "All" || activeTab === "Approved") && (
                      <th scope="col" className="px-6 py-3">
                        UTR
                      </th>
                    )}

                    <th scope="col" className="whitespace-nowrap px-6 py-3">
                      Req Amt(in ₹)
                    </th>
                    {(activeTab === "All" || activeTab === "Approved") && (
                      <th scope="col" className="px-6 py-3">
                        TDS
                      </th>
                    )}
                    {(activeTab === "All" || activeTab === "Approved") && (
                      <th scope="col" className="whitespace-nowrap px-6 py-3">
                        Processed Amt(in ₹)
                      </th>
                    )}

                    <th scope="col" className="px-6 py-3">
                      Status
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {currentRows.map((row, index) => (
                    <tr
                      className="text-md bg-white tracking-wide text-gray-700"
                      key={row.sl}
                    >
                      <td className="whitespace-nowrap border border-[#ddd9db] px-6 py-4">
                        {index + 1 + (currentPage - 1) * rowsPerPage}
                      </td>

                      <td className=" whitespace-nowrap border border-[#ddd9db] px-6 py-4">
                        <div className="flex items-center gap-4">
                          <img
                            src={row?.userId?.selected_Avatar}
                            alt="avatar"
                            className="h-10 w-10 shrink-0 rounded-full"
                          />
                          <p>{row?.kycData?.fullName}</p>
                        </div>
                      </td>

                      <td className="border border-[#ddd9db] px-6 py-4">
                        {new Date(row.createdAt)?.toLocaleDateString()}
                      </td>

                      <td className="border border-[#ddd9db] px-6 py-4">
                        {row?.kycData?.upi}
                      </td>

                      {(activeTab === "All" || activeTab === "Approved") && (
                        <td className="border border-[#ddd9db] px-6 py-4">
                          {row?.transactionId || "-"}
                        </td>
                      )}
                      <td className="border border-[#ddd9db] px-6 py-4">
                        {row?.requestedAmount?.toFixed(2)}
                      </td>

                      {(activeTab === "All" || activeTab === "Approved") && (
                        <td className="border border-[#ddd9db] px-6 py-4">
                          {row?.status !== "Pending"
                            ? `₹${(
                                row?.requestedAmount *
                                (row?.tds / 100)
                              ).toFixed(2)}(${row?.tds}%)`
                            : "-"}
                        </td>
                      )}
                      {(activeTab === "All" || activeTab === "Approved") && (
                        <td className="border border-[#ddd9db] px-6 py-4">
                          {row?.status !== "Pending"
                            ? row?.disbursedAmount?.toFixed(2) || 0
                            : "-"}
                        </td>
                      )}

                      <td
                        className={`border border-[#ddd9db] px-6 py-4 text-${
                          row?.status === "Pending"
                            ? "orange-500"
                            : row?.status === "Rejected"
                            ? "red-500"
                            : "green-500"
                        }`}
                      >
                        <div
                          className={`rounded-lg p-2 text-xs text-${
                            row?.status === "Pending"
                              ? "orange-500 bg-orange-100"
                              : row?.status === "Rejected"
                              ? "red-500 bg-red-100"
                              : "green-500 bg-green-100"
                          }`}
                        >
                          {row?.status}
                        </div>
                      </td>

                      <td className="border border-[#ddd9db] px-6 py-4">
                        {row?.status === "Pending" ? (
                          <div className="flex items-center gap-4">
                            <TbSquareRoundedCheck
                              onClick={() => handelOpenApproved("approve", row)}
                              size={28}
                              className="cursor-pointer text-[#c51369]"
                            />

                            <TbSquareRoundedX
                              onClick={() => handleOpen("reject", row)}
                              size={28}
                              className="cursor-pointer text-gray-700"
                            />
                          </div>
                        ) : row?.status === "Approved" ? (
                          <div className="flex items-center gap-4 font-mono uppercase text-green-500">
                            {row?.status}✅
                          </div>
                        ) : (
                          <div className="flex items-center gap-4 font-mono uppercase text-red-500">
                            {row?.status}❌
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          
          {/*Pagination */}
         <Pagination 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page)=>setCurrentPage(page)}
         />
        </div>
      </div>
    </React.Fragment>
  );
};

export default RequestedUsersTable;
